import React from 'react'
import { Button, Card } from 'antd'
import { AreaChartOutlined } from '@ant-design/icons'
import { handleDashboardCardClick, formatCurrency } from '../utils'
import CoreEnums from '../../../../../core/utils/enums'
import dashboardStyles from '../styles/dashboardStyles'

const RevenueTrends = ({ monthlyRevenue = [] }) => {
  return (
    <Card title='Revenue Trends' style={dashboardStyles.card}>
      <div style={dashboardStyles.chartContainer}>
        {monthlyRevenue.map((data, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '18%',
              float: 'left',
              margin: '0 1%'
            }}
          >
            <div
              style={{
                height: `${data.revenue / 600}px`,
                width: '100%',
                backgroundColor: '#1890ff',
                borderRadius: '4px 4px 0 0'
              }}
            ></div>
            <div style={{ marginTop: 8 }}>{data.month}</div>
            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{formatCurrency(data.revenue)}</div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: 'center', marginTop: 16, clear: 'both' }}>
        <Button
          type='primary'
          icon={<AreaChartOutlined />}
          onClick={() => handleDashboardCardClick(CoreEnums.tabKeys.BILLING_REPORTS)}
          style={dashboardStyles.primaryButton}
        >
          View Detailed Reports
        </Button>
      </div>
    </Card>
  )
}

export default RevenueTrends
